import { PropsWithChildren, useEffect } from "react";
import { PlayerBottomBarOverlay } from "./PlayerBottomBarOverlay";
import { AppFeature } from "features/appFeatures/types/AppFeature";
import { appFeaturesSelectors } from "features/appFeatures/store/selectors";
import { useAppSelector } from "app/hooks";

export interface VideoWithOverlayProps {
    showOverlay: boolean;
    enableAudio: boolean;
    audioEnabledByDefault: boolean;
    isMuted: boolean;
    onSetIsMuted: (muted: boolean) => void;
}

export function VideoWithOverlay(
    props: VideoWithOverlayProps & PropsWithChildren,
) {
    const userHasAudioSupportFeatureEnabled = useAppSelector((state) =>
        appFeaturesSelectors.selectUserHasFeatures(state, [
            AppFeature.DeviceAudioSupport,
        ]),
    );

    useEffect(() => {
        // reset mute state when switching camera's
        // and set muted state based on user settings
        props.onSetIsMuted(
            !userHasAudioSupportFeatureEnabled || !props.audioEnabledByDefault,
        );
    }, [
        props.enableAudio,
        props.audioEnabledByDefault,
        userHasAudioSupportFeatureEnabled,
    ]);

    return (
        <>
            {props.children}
            {props.showOverlay && (
                <PlayerBottomBarOverlay
                    isAudioEnabled={
                        userHasAudioSupportFeatureEnabled && !props.isMuted
                    }
                    AudioEnabledChanged={(enableAudio: boolean) => {
                        props.onSetIsMuted(!enableAudio);
                    }}
                />
            )}
        </>
    );
}
